module.exports = __webpack_public_path__ + "static/media/peterOzug.fc273b5e.jpg";